import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unlogged-area" }
const _hoisted_2 = { class: "unlogged-area--body" }

import UnloggedAreaHeader from '@/components/unloggedArea/UnloggedAreaHeader.vue';
import UnloggedAreaFooter from '@/components/unloggedArea/UnloggedAreaFooter.vue';
import { onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnloggedAreaLayout',
  setup(__props) {

onMounted(() => {
  document.body.classList.add('unlogged-area-layout');
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UnloggedAreaHeader),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(UnloggedAreaFooter)
  ]))
}
}

})